import React from 'react';

// Code-monkey face — lucide-style line art (no monkey exists in lucide-react).
// Uses currentColor so it inherits text color (white on the dark-blue handoff button).
const MonkeyIcon: React.FC<{ className?: string }> = ({ className = 'w-4 h-4' }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {/* ears */}
    <circle cx="5" cy="9" r="2.2" />
    <circle cx="19" cy="9" r="2.2" />
    {/* head */}
    <path d="M17.5 8.5a5.5 6 0 1 1-11 0 5.5 6 0 0 1 11 0Z" />
    {/* muzzle */}
    <ellipse cx="12" cy="14.6" rx="3.2" ry="2.4" />
    {/* eyes */}
    <circle cx="9.7" cy="10.6" r="0.55" fill="currentColor" stroke="none" />
    <circle cx="14.3" cy="10.6" r="0.55" fill="currentColor" stroke="none" />
    {/* nostrils */}
    <circle cx="10.9" cy="14.4" r="0.5" fill="currentColor" stroke="none" />
    <circle cx="13.1" cy="14.4" r="0.5" fill="currentColor" stroke="none" />
  </svg>
);

export default MonkeyIcon;
